import { defineMessages } from 'utils/intl';

export default defineMessages({
  title: 'Welcome to Rugged',
  subtitle:
    'Niezależnie od tego, czy dopiero zaczynasz budować swój van, czy jesteś doświadczonym budowniczym z wieloma vanami przygodowymi na koncie, jesteśmy tutaj, aby Ci pomóc!',
});
